import { create } from "zustand"
import { MotivoAfastamentoResume } from "../../types/rh/motivoAfastamento"
import { rhAPI } from "../../api"

interface MotivoAfastamentoState {
  cleanMotivoAfastamentoState: () => void
  //RESUME
  motivoAfastamentoResume: MotivoAfastamentoResume[]
  setMotivoAfastamentoResume: () => Promise<void>
  erroMotivoAfastamentoResume: boolean
  loadingMotivoAfastamentoResume: boolean
  setErroMotivoAfastamentoResume: (erro: boolean) => void
}

export const useMotivoAfastamentoStore = create<MotivoAfastamentoState>((set, get) => ({
  cleanMotivoAfastamentoState: () => {
    set(() => ({
      motivoAfastamentoResume: [],
      erroMotivoAfastamentoResume: false,
      loadingMotivoAfastamentoResume: false
    }))
  },
  //RESUME
  motivoAfastamentoResume: [],
  erroMotivoAfastamentoResume: false,
  loadingMotivoAfastamentoResume: false,
  setMotivoAfastamentoResume: async () => {
    set(() => ({ loadingMotivoAfastamentoResume: true, erroMotivoAfastamentoResume: false }))
    const result = await rhAPI.getMotivoAfastamentoResume()
    if (result.statusCode == 200 && result.data) {
      set(() => ({ motivoAfastamentoResume: result.data }))
    }
    else {
      set(() => ({ erroMotivoAfastamentoResume: true, motivoAfastamentoResume: [] }))
    }
    set(() => ({ loadingMotivoAfastamentoResume: false }))
  },
  setErroMotivoAfastamentoResume: (erro: boolean) => {
    set(() => ({ erroMotivoAfastamentoResume: erro }))
  },
}))